export const campaignWarningReason: {
  [identifer: string]: string;
} = {
  country: 'country',
  state: 'state',
  city: 'city',
  location: 'location',
};
  
